module.exports = {
      id: "comm-entertainment-usage",
      viewBox: "0 0 269.757 51.703",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-entertainment",
      toString: function () {
        return this.url;
      }
    }